import * as d3 from 'd3';

export function addEllipsisOverflow(
  text: d3.Selection<SVGTextElement, unknown, SVGSVGElement, undefined>,
) {
  text.each(function () {
    const text = d3.select(this);

    if (!text) return;

    const textNode = text.node();
    if (!textNode) return;
    const reverseEllipsis = text.attr('data-reverse-ellipsis') === 'true';

    // Revert to original text before calculating
    text.text(text.attr('data-original-text'));

    const containerWidth = parseInt(text.attr('width'));
    const textWidth = textNode.getComputedTextLength();

    if (!textWidth || !containerWidth) return;
    if (textWidth <= containerWidth) return;

    const originalText = text.attr('data-original-text') || text.text();
    let low = 0;
    let high = originalText.length;

    while (low < high) {
      const mid = Math.floor((low + high) / 2);
      if (reverseEllipsis) {
        text.text('...' + originalText.slice(originalText.length - mid));
      } else {
        text.text(originalText.slice(0, mid) + '...');
      }
      if (textNode.getComputedTextLength() <= containerWidth) {
        low = mid + 1;
      } else {
        high = mid;
      }
    }

    // Set the final text with the correct length
    if (reverseEllipsis) {
      text.text('...' + originalText.slice(originalText.length - (low - 1)));
    } else {
      text.text(originalText.slice(0, low - 1) + '...');
    }
  });
}
